// extracted by mini-css-extract-plugin
module.exports = {"seeker":"Seeker_seeker__1PRJp","filler":"Seeker_filler__17p6E","duration":"Seeker_duration__27izT","passed":"Seeker_passed__1z58S","rest":"Seeker_rest__19uXQ"};